(() => {
  'use strict';

  const safeUrl = 'https://judge.me/help/en/articles/8287254-how-do-we-collect-reviews';
  const selector = 'a[href="/authenticity"], a[href$="/authenticity"], a[href*="/authenticity?"]';

  function repair(root = document) {
    if (!root || !root.querySelectorAll) return 0;
    let changed = 0;
    root.querySelectorAll(selector).forEach((link) => {
      link.href = safeUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.setAttribute('aria-label', 'How Judge.me collects and labels reviews (opens in a new tab)');
      changed += 1;
    });
    return changed;
  }

  function idleRepair(root = document) {
    const run = () => repair(root);
    if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 800 });
    else setTimeout(run, 0);
  }

  function start() {
    idleRepair();
    // Judge.me can render after DOM ready. Bounded retries avoid a permanent
    // document-wide MutationObserver on every product interaction.
    [350, 1200, 3000, 6000].forEach((delay) => setTimeout(() => idleRepair(), delay));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => idleRepair(event.target));
})();
